import React, { Fragment, useState } from "react";
import { jssPreset } from "@material-ui/core/styles";
import { create } from "jss";
import { CacheProvider } from "@emotion/react";
import createCache, { EmotionCache } from "@emotion/cache";

// Define custom location to insert Emotion styles (instead of document head)
// From: https://emotion.sh/docs/cache-provider

// @ts-ignore
const ShadowDomContainer = ({ children }) => {
	const [jss, setJss] = useState(null);
	const [emotionCache, setEmotionCache] = useState(null);

	function createJssStyles(ref: any) {
		if (ref && !jss) {
			const createdJssWithRef = create({ ...jssPreset(), insertionPoint: ref });
			// @ts-ignore
			setJss(createdJssWithRef);
		}
	}

	function setEmotionStyles(ref: any) {
		if (ref && !emotionCache) {
			const createdEmotionWithRef = createCache({
				key: "my-container",
				container: ref,
			});
			// @ts-ignore
			setEmotionCache(createdEmotionWithRef);
		}
	}

	function setShadowRefs(ref: any) {
		createJssStyles(ref);
		setEmotionStyles(ref);
	}

	return (
		<Fragment>
			<div ref={setShadowRefs} />
			{jss && emotionCache && (
				<CacheProvider value={emotionCache as unknown as EmotionCache}>
					{children}
				</CacheProvider>
			)}
		</Fragment>
	);
};

export default ShadowDomContainer;
